import PropTypes from 'prop-types';
import React from 'react';

import MediaButton from '../../ui/MediaButton';
import MediaIcon from '../../ui/MediaIcon';

export default class Img extends React.PureComponent {
  static propTypes = {
    src: PropTypes.string.isRequired,

    onButtonClick: PropTypes.func,
  };

  render() {
    return (
      <div className="imgWrapper">
        <img className="mediaBlockContent" src={this.props.src} alt="" />

        <MediaButton position="top" onClick={this.props.onButtonClick} >
          <MediaIcon type="remove" />
        </MediaButton>
      </div>
    );
  }
}
